<template>
  <Layout class="g-wrapper" style="height: inherit">
    <Content class="g-main-wrapper">
      <div class="bread-crumb">
        <div class="bar-back" @click="$router.replace({ name: indexRoute, params: { id: mediaVal } })">
          <Icon type="ios-arrow-back" size="22" />
          <span>返回</span>
        </div>
        <div class="c-bar-title">
          <Breadcrumb>
            <BreadcrumbItem :to="{ name: 'plan', params: { id: $route.params.id } }">
              <Icon type="ios-home-outline" size="18" /> {{ adTitle }}
            </BreadcrumbItem>
            <BreadcrumbItem
              v-if="detailState"
              :to="{
                name: 'advert',
                params: { id: $route.params.id },
                query: { id: $route.query.id, name: encodeURI(decodeURI($route.query.name)) }
              }"
            >
              <Icon type="md-school" size="18" /> {{ decodeURI($route.query.name) }}
            </BreadcrumbItem>
            <BreadcrumbItem v-else> <Icon type="md-school" size="18" /> {{ decodeURI($route.query.name) }} </BreadcrumbItem>
            <BreadcrumbItem v-if="detailState"> <Icon type="logo-buffer" size="18" /> {{ decodeURI($route.query.adName) }} </BreadcrumbItem>
          </Breadcrumb>
        </div>
      </div>
      <Row :gutter="12">
        <Col span="24">
          <Tabs v-if="detailState" value="creative">
            <TabPane name="creative" label="创意"></TabPane>
          </Tabs>
          <Tabs v-else :value="currentRoute" @on-click="changeRouter">
            <TabPane name="advert" :label="adLabel"></TabPane>
            <TabPane name="advertidea" label="创意"></TabPane>
          </Tabs>
        </Col>
      </Row>
      <div>
        <router-view />
      </div>
    </Content>
  </Layout>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'slider',
  computed: {
    ...mapGetters('Convert', ['currentRoute']),
    detailState() {
      return this.currentRoute === 'creative'
    },
    mediaVal() {
      return parseInt(this.$route.params.id)
    },
    adTitle() {
      let title
      if (this.mediaVal === 10) title = '巨量引擎'
      else if (this.mediaVal === 6) title = '超级汇川'
      else if (this.mediaVal === 16) title = '腾讯'
      else if (this.mediaVal === 45) title = '百度信息流'
      else if (this.mediaVal === 32) title = '磁力引擎'
      return title
    },
    adLabel() {
      let label
      if (this.mediaVal === 10) label = '投放计划'
      else if (this.mediaVal === 6) label = '推广单元'
      else if (this.mediaVal === 16) label = '计划'
      else if (this.mediaVal === 45) label = '推广单元'
      else if (this.mediaVal === 32) label = '计划组'
      return label
    },
    indexRoute() {
      return this.$store.state.indexRoute
    }
  },
  methods: {
    changeRouter(name) {
      const query = this.$route.query
      this.$router.push({ name, query })
    }
  },
  watch: {
    $route(to, from) {
      if (to.name === 'creative' && from.name === 'advertidea') {
        this.$router.go(0)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.bread-crumb {
  padding: 10px 0;
  font-size: 14px;
  display: flex;
  align-items: center;

  .bar-back {
    width: 80px;
    display: flex;
    align-items: center;
    border-right: solid 1px #b9b9b9;
    cursor: pointer;
  }

  .c-bar-title {
    display: inline-block;
    padding-left: 12px;
  }
}
</style>
